import { render } from "./MissionVisionValues.vue?vue&type=template&id=725e564a"
import script from "./MissionVisionValues.vue?vue&type=script&lang=js"
export * from "./MissionVisionValues.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__